/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Component, Fragment } from 'react'

import { FormattedMessage } from '@modules/i18n'
import type { AsyncRequestState, Region } from '@modules/ui-types'
import { CuiAlert } from '@modules/cui/Alert'

export type Props = {
  fetchRegionIfNeeded: (regionId: string) => void
  region?: Region
  regionId: string
  providersRequest: AsyncRequestState
  children: React.ReactNode
}

class RegionWrapper extends Component<Props> {
  componentDidMount() {
    const { regionId, fetchRegionIfNeeded } = this.props
    fetchRegionIfNeeded(regionId)
  }

  componentDidUpdate(prevProps: Props) {
    const { regionId, fetchRegionIfNeeded } = this.props

    if (regionId !== prevProps.regionId) {
      fetchRegionIfNeeded(regionId)
    }
  }

  render() {
    const { providersRequest, regionId } = this.props

    if (providersRequest.error) {
      return (
        <CuiAlert details={providersRequest.error} type='error'>
          <FormattedMessage
            id='region-region-wrapper.fetching-region-region-id-failed'
            defaultMessage='Fetching region {regionId} failed'
            values={{ regionId }}
          />
        </CuiAlert>
      )
    }

    return <Fragment>{this.props.children}</Fragment>
  }
}

export default RegionWrapper
